var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 212,
    viewBox: "0 0 340 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1046_63369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.934 70.9864C296.088 70.9864 294.64 52.2598 298.488 51.9604C277.683 54.1746 256.321 57.5779 241.799 55.2707C236.701 61.5577 232.541 68.551 229.451 76.0322C227.489 68.9902 226.775 61.659 227.342 54.3708C224.58 54.1458 194.434 34.1574 181.741 26.7334C178.988 28.5942 176.643 30.9952 174.848 33.7905C173.052 36.5858 171.844 39.717 171.296 42.9938L215.782 70.0578L219.285 65.012C218.466 67.0268 218.008 69.1699 217.932 71.3433C217.803 75.7142 219.218 82.108 224.487 93.3328C229.629 94.8755 238.019 92.4972 244.412 88.8013C244.123 84.784 246.084 79.8668 247.562 75.7548C246.426 74.9232 245.234 74.1715 243.995 73.5051C262.848 74.7466 280.589 73.341 299.934 70.9864Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.203 100.52C133.432 99.7554 123.629 99.4872 113.83 99.7169C114.443 97.6346 114.808 95.4881 114.923 93.3213C106.889 95.4103 99.111 95.4746 88.7641 93.9979V93.8693C83.9569 97.0494 79.7603 108.325 82.7745 116.613L74.4304 134.235L50.6496 119.063C43.4827 123.53 39.8832 129.25 37.2478 138.024L67.2313 158.559C69.2425 159.94 71.5234 160.879 73.9237 161.314C76.3241 161.749 78.7895 161.671 81.1575 161.084C83.5254 160.499 85.7424 159.418 87.6625 157.914C89.5827 156.409 91.1624 154.515 92.2977 152.356L105.002 128.764L89.7875 124.903C91.56 125.938 93.4637 126.73 95.4472 127.258C105.314 129.99 119.742 128.897 129.446 127.708C126.592 139.061 124.361 150.562 122.763 162.159C128.882 166.275 136.344 167.896 143.619 166.69C149.055 151.456 153.648 135.935 157.376 120.196C157.933 117.956 157.995 115.622 157.559 113.356C157.122 111.09 156.197 108.947 154.849 107.074C153.5 105.202 151.759 103.646 149.748 102.514C147.737 101.382 145.504 100.702 143.203 100.52Z",
    fill: "#2F68E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.15 47.9688L230.767 51.1826C231.08 50.2912 231.275 49.3609 231.346 48.4187C232.294 48.3732 233.235 48.2223 234.15 47.9688Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.227 73.7179C248.002 74.3607 247.777 75.0356 247.52 75.7477C246.384 74.916 245.192 74.1643 243.953 73.498C245.399 73.5572 246.813 73.6537 248.227 73.7179Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.501 33.5C271.501 24.5 254.847 28.2755 254.847 28.2755C242.501 19.0008 238.2 26.4148 231.708 32.7427C235.05 30.0752 237.718 35.8584 237.428 39.1366C237.428 39.9096 237.846 40.0703 239.035 39.2347C241.51 37.4349 243.278 41.7093 238.618 43.7002C238.305 44.0385 238.075 44.4445 237.941 44.8843C237.087 47.3099 237.031 49.9449 237.78 52.4047C259.409 47.9763 269.001 49 270.501 33.5Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.204 53.9531L96.3472 51.3516C97.4551 51.4852 98.5732 51.5275 99.6896 51.4801C99.7775 52.3191 99.9501 53.1479 100.204 53.9531Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.24 65.0088C218.421 67.0235 217.963 69.1666 217.886 71.3401L215.733 70.0224L219.24 65.0088Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.658 65.2334C116.946 66.634 117.149 68.0514 117.269 69.4757C117.88 69.1864 118.555 68.8329 119.23 68.4794L116.658 65.2334Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.431 164.794C124.693 166.915 123.76 169.036 123.119 170.899C123.618 173.037 124.395 175.101 125.431 177.037C128.677 183.047 131.923 194.842 134.494 197.799C135.908 193.588 137.419 183.016 138.415 177.069C133.399 173.773 129.003 169.617 125.431 164.794Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 116.523C37.6909 116.427 35.4957 116.632 33.3592 117.134C26.6744 118.676 14.4313 118.676 10.9282 120.38C14.592 122.886 24.3926 127.161 29.8561 129.668C34.3726 125.684 39.564 122.538 45.1862 120.38C43.29 119.094 41.4902 117.648 39.8833 116.523Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.99 33.4214C95.9295 31.686 93.607 31.7824 93.8405 33.1001C92.3959 31.8145 89.8891 32.4235 90.1767 33.9035C88.4429 32.4894 86.4181 33.6143 86.8343 34.9641C85.3254 33.8071 83.6864 34.9641 84.2006 36.3461C82.0473 35.414 80.2476 37.0226 82.7865 39.5599C83.8792 40.6526 88.634 44.1861 91.3015 48.6534C91.4654 48.0108 91.4501 47.3357 91.2575 46.7011C91.0649 46.0666 90.7022 45.4969 90.2088 45.0539C87.5734 43.0613 89.3732 40.6848 91.0444 42.3221C92.5228 43.7684 92.0424 41.6455 90.9801 39.751C91.2 39.9413 91.4644 40.073 91.7487 40.1341C92.033 40.1952 92.3281 40.1837 92.6067 40.1005C92.8854 40.0174 93.1386 39.8654 93.343 39.6586C93.5474 39.4518 93.6964 39.1968 93.7762 38.9171C93.9869 39.0763 94.2298 39.1877 94.488 39.2434C94.7462 39.2991 95.0134 39.2978 95.271 39.2397C95.5287 39.1816 95.7705 39.068 95.9798 38.9068C96.189 38.7456 96.3606 38.5408 96.4826 38.3065C97.6666 39.1404 99.2786 38.6279 99.3429 37.3745C98.6291 36.1498 97.8256 34.8 96.99 33.4214Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6393 76.352L86.2949 79.373C85.9735 78.1213 85.6521 76.8984 85.2986 75.7109C86.3862 75.9038 88.6393 76.352 88.6393 76.352Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.481 53.8247C299.356 53.889 297.364 53.9854 296.914 54.0175C297.749 51.3517 299.231 51.3179 300.481 53.8247Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.509 69.251C300.706 71.4364 299.388 71.5328 298.263 69.5081C299.195 69.4506 300.32 69.3474 301.509 69.251Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.915 173.792C164.361 175.36 151.614 174.007 139.668 169.839",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.285 125.101C233.54 143.24 219.47 157.95 201.692 166.493",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.427 78.7627C247.139 82.6024 247.557 86.4929 247.68 90.3968",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.325 13.2031C198.083 16.1513 215.204 25.6058 227.691 39.9102",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.817 12.4961C163.475 12.2023 167.147 12.1486 170.812 12.3354C171.455 12.3693 172.13 12.3997 172.772 12.464",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.485 43.6371C114.452 28.1878 131.592 17.5755 150.756 13.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6145 97.3055C85.4832 94.5857 85.4939 91.861 85.6466 89.1423C85.8005 86.2465 86.1016 83.3625 86.5465 80.4971",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.924 161.677C113.621 155.711 105.628 147.916 99.4326 138.764",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.354 48.3934C232.289 48.3652 233.217 48.2249 234.118 47.9756L230.776 51.1573",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.104 57.1027L321.435 54.2102C325.451 52.3783 325.495 50.4246 320.696 51.9605C320.405 52.0536 313.272 54.1747 312.147 54.3388C311.279 54.4656 309.779 54.5942 309.61 54.0174C308.965 51.8184 311.64 45.8779 309.77 45.2757C308.551 44.885 306.467 48.7179 305.143 51.4784C304.216 53.4101 302.605 53.7281 300.482 53.8246",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.947 57.2303C313.947 57.2303 323.588 56.0463 324.231 55.9448C329.241 55.2157 328.891 57.1068 324.617 58.2909C320.535 59.4208 315.618 60.8281 315.618 60.8281",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.947 60.7983C317.11 60.893 320.275 60.8067 323.428 60.5412C328.472 60.147 327.925 61.8267 323.653 62.8873C321.016 63.6076 318.331 64.134 315.618 64.4621",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.509 69.2513C301.509 69.2513 308.483 68.7946 309.833 68.6728C312.435 68.436 315.107 68.0216 317.707 67.6766C318.772 67.5329 319.832 67.3637 320.889 67.1691C325.392 66.3234 326.061 64.6522 320.953 64.7909C318.211 64.8561 315.471 64.5972 312.79 64.0195",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.754 55.6885C314.243 59.6916 313.371 63.7426 311.28 67.1907",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.962 55.624C309.208 57.6189 308.047 59.435 306.553 60.9567C305.059 62.4783 303.265 63.6721 301.284 64.4621",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.247 73.7316C248.022 74.3744 247.797 75.0493 247.54 75.7614C245.869 74.6366 244.451 73.9092 243.973 73.5117C245.419 73.5709 246.833 73.6673 248.247 73.7316Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.737 70.0545L219.24 65.0088C218.329 66.9968 217.856 69.157 217.853 71.3435",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.342 54.3705C228.504 54.3705 230.006 53.3725 230.781 51.1566C231.092 50.2642 231.287 49.3351 231.359 48.3927C228.338 48.4249 224.458 46.8704 228.853 36.9852C229.798 34.8607 231.633 31.6113 233.914 32.1086C236.131 32.5941 237.654 36.5201 237.466 39.0438C237.39 40.128 238.142 39.8625 239.034 39.2282C241.524 37.4487 243.276 41.7011 238.616 43.6937C238.306 44.0337 238.075 44.438 237.939 44.8778C236.737 49.9523 236.694 54.132 241.796 55.2907",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.74 32.7445C238.232 26.4132 242.501 18.4992 254.879 28.2772C254.879 28.2772 269.001 25 270.001 31C271.501 47.5 259.474 47.9764 237.846 52.4116",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.934 70.9854C296.13 70.9854 294.638 52.2589 298.488 51.9595C277.852 54.1584 256.451 57.6006 241.799 55.2697C236.701 61.5567 232.541 68.55 229.451 76.0312C227.489 68.9892 226.775 61.6581 227.342 54.3698C224.58 54.1449 194.434 34.1564 181.741 26.7324C178.988 28.5932 176.643 30.9942 174.848 33.7895C173.052 36.5848 171.844 39.716 171.296 42.9928L217.858 71.3423C217.846 71.8616 217.858 72.4063 217.886 72.9882C218.125 77.2981 219.774 83.4366 224.417 93.32C230.16 95.0335 239.061 91.8788 244.407 88.7885C244.069 84.0912 246.806 78.1659 248.252 73.7341C265.541 74.5241 282.052 73.1539 299.934 70.9854Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.444 93.3206L196.678 123.047C191.663 128.403 188.005 134.883 186.01 141.944L175.629 178.225C178.494 180.756 181.929 182.554 185.641 183.468C189.353 184.381 193.23 184.381 196.942 183.469L207.598 144.866C239.133 117.264 233.73 121.981 237.229 118.964M237.229 118.964L254.423 145.155C255.433 146.69 256.764 147.988 258.325 148.959C259.885 149.931 261.637 150.553 263.46 150.783C265.284 151.013 267.135 150.844 268.887 150.289C270.639 149.733 272.25 148.804 273.608 147.565L306.098 117.903C305.244 114.22 303.534 110.789 301.107 107.89C298.68 104.99 295.604 102.703 292.128 101.215L266.955 124.558C266.955 124.558 262.616 95.9238 244.363 88.7891M237.229 118.964L234 113.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.654 179.769C176.387 186.585 174.449 193.259 171.869 199.694C169.422 205.219 167.503 210.167 168.205 211.007C170.665 213.949 179.031 201.242 185.239 197.991C186.718 197.257 188.039 196.242 189.129 195.002C191.31 192.428 190.092 189.442 192.631 184.075",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.788 113.952C310.109 109.423 315.689 105.206 321.5 101.324C326.544 97.9795 330.818 94.8316 330.689 93.7711C330.234 89.9787 316.295 96.124 309.351 95.5387C307.7 95.3663 306.032 95.5081 304.434 95.9565C301.22 96.9274 300.802 99.9738 295.757 103.156",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.616 23.0693C170.616 15.965 176.14 2.72059 178.297 1.63465C178.383 1.59576 178.48 1.59205 178.569 1.6243C178.657 1.65656 178.73 1.7222 178.77 1.80718C178.797 1.863 178.809 1.92559 178.804 1.98818C178.065 9.57625 173.143 22.5365 180.004 27.995",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.126 39.7495C169.652 38.0783 166.16 35.1825 166.277 32.3577C166.6 24.5497 166.551 20.8842 166.566 17.7989C166.578 15.5171 168.373 15.4511 169.587 19.4058C170.653 22.8751 171.773 27.7619 171.773 27.7619",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.301 10.9848C177.977 9.85997 178.71 8.70129 179.004 8.2226C181.152 4.72796 182.015 5.58385 181.832 6.23001C181.117 8.75711 179.39 12.5596 178.811 14.9057C177.948 18.3581 176.48 23.1771 179.217 27.2773",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.489 125.271C144.489 125.271 138.093 126.652 129.448 127.713",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5181 97.467C86.3531 96.075 87.4558 94.8625 88.7624 93.8996V94.0282C99.111 95.5065 106.889 95.4423 114.923 93.3516C114.809 95.5186 114.442 97.665 113.83 99.7471C123.629 99.5227 133.432 99.7909 143.203 100.551C145.501 100.728 147.733 101.404 149.742 102.534C151.751 103.663 153.49 105.217 154.836 107.088C156.182 108.959 157.104 111.101 157.537 113.365C157.97 115.629 157.904 117.96 157.343 120.196C153.621 135.939 149.029 151.463 143.589 166.698C136.313 167.905 128.851 166.284 122.731 162.167C124.33 150.57 126.562 139.069 129.416 127.716C119.712 128.9 105.285 129.988 95.4168 127.266C89.5693 125.654 84.8026 122.288 82.7305 116.564C80.3641 110.069 82.4954 102.19 85.5181 97.467Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.862 99.7812C112.256 99.8134 110.681 99.8777 109.106 99.9419",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.708 128.735L92.2926 152.357C90.5818 155.611 87.8772 158.234 84.5725 159.845C81.2677 161.456 77.5351 161.97 73.9178 161.313C71.5178 160.878 69.2373 159.94 67.2263 158.56L37.2478 138.025C39.8865 129.241 43.4911 123.517 50.6749 119.048L74.3982 134.236L82.7542 116.56",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.204 53.9527L96.3472 51.3174C97.4579 51.4417 98.5769 51.4739 99.693 51.4138",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.403 54.7562C106.824 55.1098 106.246 55.4329 105.667 55.7847C105.039 56.2783 104.262 56.5439 103.463 56.5381C102.664 56.5323 101.89 56.2553 101.269 55.7525C100.284 54.5176 99.732 52.9932 99.6978 51.4138C104.867 51.1111 105.183 47.635 99.3409 37.3389C99.2795 37.6383 99.14 37.9162 98.9364 38.1441C98.7328 38.3721 98.4724 38.5421 98.1818 38.6368C97.8912 38.7315 97.5807 38.7475 97.2818 38.6832C96.983 38.619 96.7066 38.4767 96.4806 38.2709C96.365 38.5115 96.1966 38.7228 95.9878 38.889C95.7791 39.0552 95.5354 39.1721 95.2751 39.2308C95.0147 39.2896 94.7445 39.2887 94.4846 39.2282C94.2247 39.1677 93.9818 39.0492 93.7742 38.8815C93.6942 39.161 93.5452 39.4159 93.3408 39.6226C93.1365 39.8294 92.8834 39.9814 92.6049 40.0646C92.3263 40.1479 92.0313 40.1597 91.747 40.0989C91.4628 40.0382 91.1983 39.9069 90.9781 39.7171C92.0708 41.6116 92.5208 43.7327 91.0424 42.2865C89.3712 40.6491 87.5714 43.0578 90.2085 45.02C90.7021 45.4625 91.0649 46.0319 91.2575 46.6662C91.4502 47.3005 91.4653 47.9755 91.3012 48.6178C92.8259 50.8419 93.4353 53.5679 93.0028 56.2295C92.7136 57.5827 90.7853 58.6399 88.4358 58.0293C91.2386 63.0649 97.0066 67.7047 102.616 65.7222C108.788 63.5487 107.403 54.7562 107.403 54.7562Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.334 28.3468C155.272 22.3437 155.585 9.65065 155.585 0.548686C155.585 0.25944 156.001 -0.127914 156.226 0.0412359C158.234 1.34707 160.905 14.8808 160.262 22.002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.443 39.1386C158.72 38.2215 160.607 36.5396 161.778 34.3821C164.225 28.9355 165.082 22.9079 164.249 16.9951C163.813 14.4274 162.48 14.649 161.325 18.5378C160.294 22.0087 158.689 26.6688 158.689 26.6688",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2 28.2622C149.413 25.5558 151.495 20.752 151.399 18.2164C151.139 15.3737 150.645 12.5573 149.92 9.79612C149.775 9.11952 150.619 8.21964 153.07 12.8408",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.269 69.4757C117.149 68.0508 116.945 66.6343 116.658 65.2334L119.192 68.4354",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.955 93.3529H114.988C116.37 85.1897 117.88 76.9301 117.269 69.4757C130.103 62.7435 146.414 49.6936 156.512 40.8098C157.657 39.6647 153.647 34.5936 152.544 33.2928C151.412 31.9582 146.987 27.0444 145.426 27.8259C133.629 37.9671 120.91 46.9831 107.435 54.7563",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.343 167.108C139.515 170.389 138.882 173.716 138.447 177.071C133.418 173.778 129.02 169.609 125.463 164.762C125.591 164.481 125.7 164.192 125.784 163.895",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.431 177.029C124.395 175.093 123.618 173.029 123.119 170.891C122.572 172.183 122.285 173.571 122.273 174.974C122.677 176.975 123.381 178.903 124.362 180.693C127.672 186.863 130.982 199.783 133.361 199.622C133.714 199.59 134.1 198.915 134.486 197.791C131.955 194.841 128.709 183.046 125.431 177.029Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.431 164.794C124.693 166.915 123.76 169.036 123.119 170.899C123.618 173.037 124.395 175.101 125.431 177.037C128.677 183.047 131.923 194.842 134.494 197.799C135.908 193.588 137.419 183.016 138.415 177.069C133.399 173.773 129.003 169.617 125.431 164.794Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6298 133.942C35.7939 132.342 32.864 130.915 29.856 129.668C34.3599 125.692 39.5415 122.557 45.1539 120.412C46.0216 120.991 46.1502 121.216 46.9858 121.698",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1873 114.659C34.1497 114.506 32.1008 114.669 30.1131 115.143C23.2997 116.716 9.9318 116.459 9.47678 118.805C9.41251 119.158 9.95886 119.705 10.923 120.38C14.4261 118.676 26.6692 118.676 33.3861 117.166C35.5223 116.663 37.7179 116.458 39.9102 116.557C38.8105 115.679 37.5439 115.033 36.1873 114.659Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 116.523C37.6909 116.427 35.4957 116.632 33.3592 117.134C26.6744 118.676 14.4313 118.676 10.9282 120.38C14.592 122.886 24.3926 127.161 29.8561 129.668C34.3726 125.684 39.564 122.538 45.1862 120.38C43.29 119.094 41.4902 117.648 39.8833 116.523Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4766 70.5364C18.0181 71.0205 16.552 71.4812 15.0787 71.9184C12.1203 72.8115 11.0293 72.2719 13.986 70.2472C16.7816 68.3489 19.8662 66.9163 23.1201 66.0049",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0636 62.2764C25.1711 63.1479 24.3634 64.1022 23.6515 65.1265C22.3738 67.0408 21.5096 69.2007 21.1143 71.468",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.352 67.7726C7.64989 71.5328 6.30683 69.7787 15.2667 65.6836C18.7237 64.2037 22.3227 63.0804 26.0077 62.3311",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3113 70.5993C34.8339 70.3489 25.2803 72.0184 18.3519 74.3206C15.3309 75.3169 13.7155 74.6589 17.0664 72.1352C18.4781 71.0799 19.9909 70.1671 21.5827 69.4102",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7607 63.6263C17.1628 64.4619 8.96246 64.7698 21.7248 60.6374C23.7174 59.993 26.1227 59.4534 28.3775 58.9662C28.5048 58.1283 28.3583 57.2717 27.9597 56.5237C26.6065 54.2571 27.0632 53.3369 29.2774 54.6918C32.0875 56.6042 35.4241 57.5928 38.8225 57.52",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3775 58.9639C28.3636 59.8123 28.5248 60.6546 28.8512 61.4379C29.1776 62.2212 29.6622 62.9287 30.2746 63.5161C30.8869 64.1036 31.614 64.5583 32.4101 64.8519C33.2063 65.1455 34.0545 65.2716 34.9017 65.2224",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3358 37.3708C99.2715 38.6242 97.6646 39.1384 96.4755 38.3028C96.3537 38.5373 96.1822 38.7424 95.973 38.9037C95.7638 39.0651 95.5219 39.1788 95.2641 39.237C95.0064 39.2951 94.7391 39.2963 94.4809 39.2404C94.2226 39.1845 93.9797 39.073 93.7691 38.9135C93.6885 39.1925 93.5392 39.4469 93.3347 39.6532C93.1302 39.8595 92.8772 40.0111 92.5988 40.0941C92.3205 40.1771 92.0257 40.1889 91.7417 40.1283C91.4576 40.0677 91.1933 39.9367 90.973 39.7474C92.0336 41.6435 92.5157 43.7664 91.0373 42.3185C89.3661 40.6811 87.5731 43.0509 90.2017 45.0502C90.6959 45.4927 91.0591 46.0624 91.2518 46.6971C91.4445 47.3318 91.4592 48.0072 91.2944 48.6497C88.6286 44.1842 83.8721 40.6489 82.7794 39.5562C80.2421 37.019 82.0402 35.4104 84.1935 36.3424C83.686 34.9604 85.3183 33.8051 86.8272 34.9604C86.4094 33.6072 88.4358 32.4858 90.1696 33.8999C89.8803 32.4215 92.3871 31.8109 93.8333 33.0964C93.6084 31.7787 95.9274 31.6789 96.9829 33.4178C97.8287 34.7964 99.3358 37.3708 99.3358 37.3708Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2896 79.373L88.639 76.352C87.4838 76.1287 86.391 75.9021 85.2983 75.7109",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4428 58.034C88.025 57.8733 67.8065 52.6026 39.4012 55.3276C37.8607 61.08 38.0371 67.1575 39.9086 72.811C55.0973 71.5761 70.3849 72.5521 85.2933 75.7085C87.1038 81.6281 88.2671 87.7267 88.7625 93.8972",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5653 54.6592C47.9922 60.527 48.2865 66.7365 50.4009 72.4318",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.384 32.9043C144.214 36.1345 148.147 40.5372 150.813 45.7005",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.481 53.8247C299.356 53.889 297.363 53.9854 296.913 54.0175C297.749 51.3517 299.231 51.3179 300.481 53.8247Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.509 69.251C300.706 71.4364 299.388 71.5328 298.263 69.5081C299.195 69.4506 300.32 69.3474 301.509 69.251Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.499 151.199C127.752 153.546 131.458 155.19 135.381 156.026C139.304 156.862 143.358 156.872 147.285 156.056",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3254 124.593C53.0279 128.835 49.0073 135.713 46.5681 144.383",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.344 28.3473C151.949 24.8763 153.07 19.7206 153.231 15.0301C152.901 11.7497 152.343 8.4963 151.559 5.29383C151.458 4.65106 152.363 3.87973 154.195 7.57566L155.255 9.88287",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1046_63369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 212,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupApproval);
export default __webpack_public_path__ + "static/media/signup_approval.27f7669372ba28b3dc3213cbb46baeaa.svg";
export { ForwardRef as ReactComponent };